import type { AxiosInstance } from "axios";

import { useQuery } from "@tanstack/react-query";

import { usePrivateAxios } from "./use-private-axios";

async function fetchVendors(privateAxios: AxiosInstance) {
	const { data } = await privateAxios.get("/auth/vendor-for-buyer");
	return data;
}

export function useVendors() {
	const privateAxios = usePrivateAxios();
	return useQuery({
		queryKey: ["vendors"],
		queryFn: () => fetchVendors(privateAxios)
	});
}

interface Vendor {
	createdAt: string;
	updatedAt: string;
	deletedAt: string | null;
	id: string;
	firstName: string;
	lastName: string;
	fullName: string;
	status: "ACTIVE" | "INACTIVE";
	othername: null;
	email: string;
	gender: null;
	username: string;
	profileImage: string;
	phoneNumber: null;
	address: string | null;
	shippingAddress: string | null;
	city: string | null;
	userType: "VENDOR";
	language: "English";
	averageRating: null;
	buyerCount: 2;
	phoneVerified: false;
	countryId: "61f1be96-58fe-4de3-b6fc-ba738f5322dd";
	business: null;
	socials: [];
	__type: "User";
}

export function useVendor(vendorId: string) {
	const privateAxios = usePrivateAxios();
	return useQuery({
		queryKey: ["vendor", vendorId],
		queryFn: async () => {
			const { data } = await privateAxios.get<{ data: Vendor }>(`/auth/${vendorId}/retrieve`);
			return data;
		}
	});
}
